import { C } from '../../styles/tokens';

// Matches GenerationsTable.js's own column-header row + data-row grid exactly, since it's
// passed the same computed gridTemplateColumns — used by Dubbing, Voice Changer, Voice Isolator.
export default function GenerationsTableSkeleton({ gridTemplateColumns, rows = 4, isMobile }) {
    if (isMobile) {
        return (
            <div>
                {Array.from({ length: rows }).map((_, i) => (
                    <div
                        key={i}
                        style={{
                            display: 'flex', flexDirection: 'column', gap: 8,
                            padding: '14px 16px', borderBottom: i < rows - 1 ? `1px solid ${C.n100}` : 'none',
                        }}
                    >
                        <div className="shine rounded-2" style={{ height: 13, width: '55%' }} />
                        <div className="shine rounded-2" style={{ height: 11, width: '35%' }} />
                    </div>
                ))}
            </div>
        );
    }

    // Middle cells = columns.length (variable per caller — Dubbing has 3, Voice Changer/
    // Isolator have 2); first cell is always the title, last is always the actions circle.
    const cellCount = gridTemplateColumns.split(' ').length;
    const middleCells = Math.max(0, cellCount - 2);

    return (
        <div>
            {Array.from({ length: rows }).map((_, i) => (
                <div
                    key={i}
                    style={{
                        display: 'grid', gridTemplateColumns, gap: 12, alignItems: 'center',
                        padding: '14px 20px', borderBottom: i < rows - 1 ? `1px solid ${C.n100}` : 'none',
                    }}
                >
                    <div className="shine rounded-2" style={{ height: 13, width: '70%' }} />
                    {Array.from({ length: middleCells }).map((_, j) => (
                        <div key={j} className="shine rounded-2" style={{ height: 11, width: '60%', margin: '0 auto' }} />
                    ))}
                    <div className="shine rounded-circle" style={{ height: 28, width: 28, margin: '0 auto' }} />
                </div>
            ))}
        </div>
    );
}
